module.exports = __webpack_public_path__ + "static/media/f72facda.jpg";